import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MessagesHeader } from "./components/MessagesHeader";
import { MessagesTable } from "./components/MessagesTable";
import { MessageDialog } from "./components/MessageDialog";

// Mock data for owners
const mockOwners = [
  { id: "1", name: "João Silva", email: "joao@email.com" },
  { id: "2", name: "Maria Santos", email: "maria@email.com" },
];

// Mock data for properties
const mockProperties = [
  {
    id: "1",
    title: "Apartamento Luxo",
    link: "https://example.com/apt1",
    price: 500000,
    ownerId: "1"
  },
  {
    id: "2",
    title: "Casa com Piscina",
    link: "https://example.com/house1",
    price: 850000,
    ownerId: "2"
  }
];

// Mock data for scheduled messages
const mockScheduledMessages = [
  {
    id: "1",
    ownerId: "1",
    propertyId: "1",
    message: "Verificação mensal de disponibilidade",
    interval: "30days",
    nextDate: new Date(),
  },
  {
    id: "2",
    ownerId: "2",
    propertyId: "2",
    message: "Atualização bimestral",
    interval: "60days",
    nextDate: new Date(),
  },
];

const MessagesPage = () => {
  const { toast } = useToast();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMessage, setSelectedMessage] = useState<any>(null);
  const [messageToDelete, setMessageToDelete] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Add filtering logic
  const filteredMessages = mockScheduledMessages.filter((schedule) => {
    const owner = mockOwners.find(o => o.id === schedule.ownerId);
    const property = mockProperties.find(p => p.id === schedule.propertyId);
    
    const searchLower = searchTerm.toLowerCase();
    return (
      !searchTerm ||
      owner?.name.toLowerCase().includes(searchLower) ||
      property?.title.toLowerCase().includes(searchLower)
    );
  });

  const handleDeleteSchedule = (scheduleId: string) => {
    toast({
      title: "Agendamento excluído",
      description: "O agendamento foi removido com sucesso.",
    });
    setMessageToDelete(null);
  };

  const handleViewMessage = (schedule: any) => {
    setSelectedMessage(schedule);
    setIsDialogOpen(true);
  };

  return (
    <div className="space-y-8">
      <MessagesHeader 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      <div className="bg-white p-4 md:p-6 rounded-xl shadow-card space-y-6">
        <MessagesTable
          filteredMessages={filteredMessages}
          mockOwners={mockOwners}
          mockProperties={mockProperties}
          onViewMessage={handleViewMessage}
          onDeleteMessage={setMessageToDelete}
        />
      </div>

      <MessageDialog
        selectedMessage={selectedMessage}
        mockOwners={mockOwners}
        mockProperties={mockProperties}
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />

      <AlertDialog 
        open={messageToDelete !== null} 
        onOpenChange={(open) => !open && setMessageToDelete(null)}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja excluir este agendamento de mensagem? Esta ação não pode ser desfeita.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={() => messageToDelete && handleDeleteSchedule(messageToDelete)}>
              Confirmar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default MessagesPage;